'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.Configuration', 'AVRO.Common.UserPreferences'];
module.exports = angular.module('AVRO.Common.ClassIndices', dependencies).factory('ClassIndicesService', require('./services/ClassIndicesService')).factory('FcrService', require('./services/FcrService'));